import React, { Component } from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { observer, inject } from 'mobx-react';
import * as loginUtil from '../../Utils/loginUtil';
import Icon from '../Icon';
import styles from './style';
import { RootStoreInterface } from '../../Store/index';
import { qav } from '../../Utils/qav';
import LoginManager from '../../Utils/LoginManager';
interface Props {
    showLoginBar?: boolean;
    pageName?: string;
    loginManager: LoginManager;
    onloginSuc?(): void;
}

@inject((store: RootStoreInterface) => ({
    showLoginBar: store.uiState.showLoginBar,
    onloginSuc: store.onloginSuc,
    pageName: store.pageName,
    loginManager: store.loginManager
}))
@observer
class LoginBar extends Component<Props> {
    public onPressLogin = async () => {
        const { onloginSuc, pageName } = this.props;
        qav({
            page: pageName,
            module: 'loginBtn',
            path: [{ title: '登录', position: '0' }],
            operType: 'click'
        });
        this.props.loginManager.isLogining = true;
        if (await loginUtil.login()) {
            onloginSuc();
        }
    };

    public render() {
        const { showLoginBar } = this.props;
        if (!showLoginBar) {
            return null;
        }
        return (
            <View style={styles.hasOrderLogin}>
                <View style={styles.hasOrderLoginLeft}>
                    <Icon code="&#xe6cf;" style={styles.noticeIcon} />
                    <Text
                        style={[styles.hasOrderLoginText, { width: '100%', paddingRight: 20 }]}
                        numberOfLines={1}
                    >
                        您还未登录，登录查看更多订单
                    </Text>
                </View>
                <TouchableOpacity
                    activeOpacity={1}
                    style={styles.loginBtn}
                    onPress={this.onPressLogin}
                    accessible={false}
                >
                    <Text style={styles.loginBtnText} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.BTN_LOGIN)}>去登录</Text>
                </TouchableOpacity>
            </View>
        );
    }
}
export default LoginBar;
